import { Component, OnInit, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { ControlContainer, FormGroup, Validators } from '@angular/forms';
import { Observable, forkJoin } from 'rxjs';
import { first } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../app-reducer';

// Services
import { ApiService } from 'src/app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { QuestionBase } from 'src/app/models/question-base';
import { QuestionService } from '../../services/question.service';
import { NavigationService } from '../../services/navigation.service';
import { ModalComponent } from 'src/app/components/modal.component';
import { AppConstants } from '../../app.constants';

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html'
})

export class FileUploadComponent implements OnInit, AfterViewInit {
  @Input() parent: FormGroup;
  @Input() isEditable: boolean;
  @Input() isRequired: boolean;
  @Input() question: any;
  @Input() questions: QuestionBase<any>[] = [];

  blockIndex: number = 1;
  appState$: Observable<any>;
  uploadResponse: string;
  illustrationFiles = [];
  public oopsMsg: any = false;
  public tooManyFiles: string = 'This question only accepts one illustration file.';
  public badResponse: string = 'Something has gone wrong.  Please try again.';
  public onlyPDFs: string = 'This question only accepts PDF files.';
  public filePickerFormGroup: FormGroup;
  formGroupParent: any;
  preFillContent: any = null;
  defaultValues: any = null;
  isOptional = false;
  throwOverlay = false;
  illustrationStart: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private apiService: ApiService,
    private qs: QuestionService,
    private navigationService: NavigationService,
    private controlContainer: ControlContainer,
    private warningPopup: MatDialog,
    private disclosurePopup: MatDialog,
    private appConstants: AppConstants
  ) {
    // get questions from state
    this.appState$ = this.store.select('sections');
  }

  ngOnInit() {
    this.filePickerFormGroup = <FormGroup>this.controlContainer.control;
    this.formGroupParent = this.controlContainer.name;
    this.uploadResponse = this.question.QuestionName + 'response';
    if (this.question['IsOptional'] == true) {
      this.isOptional = true;
    }
    this.isEditable = this.isEditable == null ? true : this.isEditable;
    this.illustrationStart = this.filePickerFormGroup.parent['controls']['IllustrationPrePop'] ? true : false;
  }

  ngAfterViewInit() {
    // repopulate file uploaded status from state when returning to the block
    window["setTimeout"](() => {
      if (this.filePickerFormGroup.value && this.filePickerFormGroup.value['Response']) {
        const { FileName } = JSON.parse(this.filePickerFormGroup.value['Response']);
        if (FileName !== 'none') {
          this.illustrationFiles[0] = { name: FileName, progress: 100, size: 'uploaded' };
        }
        this.filePickerFormGroup.controls['Upload'].clearValidators();
        this.filePickerFormGroup.controls['Upload'].updateValueAndValidity();
        this.cdr.detectChanges();
      } else if (this.isOptional) {
        this.filePickerFormGroup.controls['Response'].setValue('{\"FileName\":\"none\"}');
      }
    }, 750);
  }

  onFileDropped($event) {
    this.prepareFiles($event);
  }

  fileBrowseHandler(files) {
    this.prepareFiles(files);
  }

  deleteFile(index: number) {
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      if (!this.illustrationStart && state.illustrationFile && state.illustrationUploadId === state.appId) {
      //on an error response, open error popup
      const modalRef = this.disclosurePopup.open(ModalComponent, {
        disableClose: true,
        closeOnNavigation: true,
        data: {
          size: '',
          // Array of screens
          screens: [
            {
              show: true,
              exit_btn: true,
              content: [
                {
                  type: 'title',
                  content: 'Are you sure you\'d like to re-upload?',
                  class: this.appConstants.modalTitleBold
                },
                {
                  type: 'text',
                  content: 'We will be unable to update the application questions accordingly.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'button_group',
                  buttons: [
                    {
                      type: 'button',
                      label: 'No',
                      clickFunction: 'continueIllustrationCertification',
                      class: this.appConstants.buttonSecondary
                    },
                    {
                      type: 'button',
                      label: 'Yes',
                      clickFunction: 'retryUpload',
                      class: this.appConstants.buttonPrimary
                    }
                  ]
                }
              ]
            }
          ]
        }
      });
      modalRef.afterClosed().pipe(first()).subscribe(result => {
        if (result.event == "Retry") {
          this.delete(index, state);
         } 
        })
    } else {
      this.delete(index, state);
}
});

    this.navigationService.updateNav(this.filePickerFormGroup.controls, 'IllustrationCertification');
  }

  delete(index: number, state: any) {
    this.illustrationFiles.splice(index, 1);
    this.filePickerFormGroup.reset();
    this.filePickerFormGroup.controls['Upload'].markAsDirty();
    if (this.isOptional == false) {
      this.filePickerFormGroup.controls['Upload'].setValidators(Validators.required);
      this.filePickerFormGroup.controls['Response'].setValidators(Validators.required);
      this.filePickerFormGroup.updateValueAndValidity();
    }
    if (this.illustrationStart) {
      this.filePickerFormGroup.parent['controls']['IllustrationStartSignaturePresent'].enable();
      this.filePickerFormGroup.parent['controls']['IllustrationStartSignaturePresent'].setValue('true');
    } else {
      this.filePickerFormGroup.parent['controls']['IllustrationSignaturePresent'].enable();
      this.filePickerFormGroup.parent['controls']['IllustrationSignaturePresent'].setValue('true');
    }
    this.filePickerFormGroup.parent.updateValueAndValidity();
    this.cdr.markForCheck();

      if (state.content.IllustrationCertification) {
        if (state.content.IllustrationCertification.IllustrationUpload) {
          state.content.IllustrationCertification.IllustrationUpload.Response = null;
        } else {
          state.content.IllustrationCertification.IllustrationUploadProtectionTerm.Response = null;
        }
      }
    
  }
  async uploadIllustrationStart() {
    this.navigationService.disableButton(true);
    this.throwOverlay = true;
    let appAuthId: string;
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      appAuthId = state.appAuthId;
      state.illustrationUploadId = state.appId;
    });
    forkJoin([
      this.apiService.startAppWithIllustration(this.illustrationFiles[0]),
      this.apiService.uploadIllustrationFile(appAuthId, "IllustrationUpload", this.illustrationFiles[0]),
    ]).subscribe(([jsonData, uploadData]: any) => {
        const fullResponse = uploadData;
        const blocks = ["SECTIONAProposedInsured",
          "SECTIONDCoverageDetails",
          "CriticalIllness",
          "IULPremandSegmentProceedsAllocations",
          "VULFundAllocation",
          "SupplementCostBenefitPA",
          "SupplementCostBenefitME"];
        if (jsonData['startAppResp']['status'] !== 'error' && !(fullResponse[0].response.includes('ApplicantSignatureField":false'))) {
          blocks.forEach(b => {
            this.navigationService.submitIllustrationPayloadValues(jsonData['startAppResp']['response'], b);
          });
          const fields = {
          "IllustrationUpload": { "Upload": null, "Response": fullResponse[0].response },
          "IllustrationUploadProtectionTerm": { "Upload": null, "Response": fullResponse[0].response },
          "IllustrationSignaturePresent": true
          };
          this.navigationService.submitIllustrationPayloadValues(fields, "IllustrationCertification");
      
          this.filePickerFormGroup.parent['controls']['IllustrationStartSignaturePresent'].enable();
          this.filePickerFormGroup.parent['controls']['IllustrationStartSignaturePresent'].setValue('true');

          // complete fake progress meter
          this.illustrationFiles[0].progress = 100;
          this.navigationService.disableButton(false);
          // copy http response to "Response" control be swapped in as the question value in the block submission
          this.filePickerFormGroup.controls['Response'].patchValue(fullResponse[0].response);
          // clear "Upload" control value and remove its validation for block submission
          this.filePickerFormGroup.controls['Upload'].clearValidators();
          // this.filePickerFormGroup.controls['Upload'].updateValueAndValidity();
          this.filePickerFormGroup.controls['Upload'].setValue(null);
          this.cdr.detectChanges();
          this.appState$.pipe(first()).subscribe((state: any) => {
          state.illustrationFile = this.illustrationFiles[0];
          });
        
        } else {
          //on an error response, open error popupnp
          const modalRef = this.warningPopup.open(ModalComponent, {
            disableClose: true,
            closeOnNavigation: true,
            data: {
              size: '',
              // Array of screens
              screens: [
                {
                  show: true,
                  exit_btn: false,
                  content: [
                    {
                      type: 'title',
                      content: 'Warning',
                      class: this.appConstants.modalTitleBold
                    },
                    {
                      type: 'text',
                      content: 'The application could not be pre-populated at this time due to a system error while uploading your illustration. Please try again or continue without prefilling.',
                      class: this.appConstants.modalParagraphDefault
                    },
                    {
                      type: 'text',
                      content: 'Otherwise, you can contact support team and continue filing up the form after closing this message.',
                      class: this.appConstants.modalParagraphDefault
                    },
                    {
                      type: 'button_group',
                      buttons: [
                        {
                          type: 'button',
                          label: 'Close',
                          clickFunction: 'retryUpload',
                          class: 'btn btn-primary illus-btn-small'
                        },
                      ]
                    },
                  ]
                }
              ]
            }
          });
          
          modalRef.afterClosed().pipe(first()).subscribe(result => {
            if (result.event == "Retry" || result.event == "Continue") {
              this.deleteFile(0);
              this.filePickerFormGroup.parent['controls']['IllustrationStartSignaturePresent'].enable();
              this.filePickerFormGroup.parent['controls']['IllustrationStartSignaturePresent'].setValue('false');
              // copy http response to "Response" control be swapped in as the question value in the block submission
              this.filePickerFormGroup.controls['Response'].setValue(fullResponse[0].response);

              // clear "Upload" control value and remove its validation for block submission
              this.filePickerFormGroup.controls['Upload'].setValue(null);
              this.filePickerFormGroup.controls['Upload'].clearValidators();
              this.navigationService.disableButton(false);
              this.throwOverlay = false;
            }
          })
          this.appState$.pipe(first()).subscribe((state: any) => {
            state.illustrationFile = 'error during upload or invalid file'
            });
        }
      
      
      }, errorResponse => {
        this.illustrationFiles[0].progress = 'break';
        this.oopsMsg = this.badResponse;
        this.deleteFile(0);
        this.illustrationFiles = [];
      }, () => {
          this.throwOverlay = false;
        
    });

  }

  async uploadIllustration() {
    this.navigationService.disableButton(true);
    this.throwOverlay = true;
    let appAuthId: string;
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      appAuthId = state.appAuthId;
    });
      
    this.apiService.uploadIllustrationFile(appAuthId, this.question.QuestionName, this.illustrationFiles[0]).pipe(
      first()
      ).subscribe(response => {

        const fullResponse = response;

        if (fullResponse[0].response.includes('ApplicantSignatureField":false')) {
          //set progress to uploaded
          this.illustrationFiles[0].progress = 100;

          //on an error response, open error popup
          const modalRef = this.warningPopup.open(ModalComponent, {
            disableClose: true,
            closeOnNavigation: true,
            data: {
              size: '',
              // Array of screens
              screens: [
                {
                  show: true,
                  exit_btn: false,
                  content: [
                    {
                      type: 'title',
                      content: 'Further Action Required',
                      class: this.appConstants.modalTitleBold
                    },
                    {
                      type: 'text',
                      content: 'The illustration you uploaded cannot be signed for one of the following reasons:',
                      class: this.appConstants.modalParagraphDefault
                    },
                    {
                      type: 'unordered_list',
                      unordered_list: [
                        {
                          type: 'unordered_list_item',
                          content: 'It is not compatible with our eSignature process',
                          class: this.appConstants.modalLiDefault
                        },
                        {
                          type: 'unordered_list_item',
                          content: 'The case is owned by a Third Party',
                          class: this.appConstants.modalLiDefault
                        }
                      ]
                    },
                    {
                      type: 'text',
                      content: 'If you think that you’ve uploaded the wrong file, please try again.',
                      class: this.appConstants.modalParagraphDefault
                    },
                    {
                      type: 'text',
                      content: 'Otherwise, to satisfy our illustration requirement, you will be asked to complete the Illustration Certification after closing this message. The Illustration Certification and the uploaded, unsigned illustration will be included in the application package for your review.',
                      class: this.appConstants.modalParagraphDefault
                    },
                    {
                      type: 'button_group',
                      buttons: [
                        {
                          type: 'button',
                          label: 'Try Again',
                          clickFunction: 'retryUpload',
                          class: 'btn btn-primary illus-btn-small'
                        },
                        {
                          type: 'button',
                          label: 'Continue with Illustration Certification',
                          clickFunction: 'continueIllustrationCertification',
                          class: 'btn btn-primary modal-btn-long-text illus-btn-large'
                        }
                      ]
                    },
                  ]
                }
              ]
            }
          });

          modalRef.afterClosed().pipe(first()).subscribe(result => {
            if (result.event == "Retry") {
              this.deleteFile(0);
            } else if (result.event == "Continue") {
              //set hidden question to false to trigger child questions
              this.filePickerFormGroup.parent['controls']['IllustrationSignaturePresent'].enable();
              this.filePickerFormGroup.parent['controls']['IllustrationSignaturePresent'].setValue('false');
              // copy http response to "Response" control be swapped in as the question value in the block submission
              this.filePickerFormGroup.controls['Response'].setValue(fullResponse[0].response);

              // clear "Upload" control value and remove its validation for block submission
              this.filePickerFormGroup.controls['Upload'].setValue(null);
              this.filePickerFormGroup.controls['Upload'].clearValidators();
              this.navigationService.disableButton(false);
              this.throwOverlay = false;
            } 
          })

        } else if (!fullResponse[0] || fullResponse[0].status === 'error') {
          this.illustrationFiles[0].progress = 'break';
          this.oopsMsg = this.badResponse;
          this.deleteFile(0);
          this.illustrationFiles = [];
          return;
        } else {

          this.filePickerFormGroup.parent['controls']['IllustrationSignaturePresent'].enable();
          this.filePickerFormGroup.parent['controls']['IllustrationSignaturePresent'].setValue('true');
          
          // complete fake progress meter
          this.illustrationFiles[0].progress = 100;
          this.navigationService.disableButton(false);

          // copy http response to "Response" control be swapped in as the question value in the block submission
          this.filePickerFormGroup.controls['Response'].patchValue(fullResponse[0].response);

          // clear "Upload" control value and remove its validation for block submission
          this.filePickerFormGroup.controls['Upload'].clearValidators();
          // this.filePickerFormGroup.controls['Upload'].updateValueAndValidity();
          this.filePickerFormGroup.controls['Upload'].setValue(null);
          this.cdr.detectChanges();
        }
      }, errorResponse => {
        this.illustrationFiles[0].progress = 'break';
        this.oopsMsg = this.badResponse;
        this.deleteFile(0);
        this.illustrationFiles = [];
      }, () => {
          this.throwOverlay = false;
        
      });
    
    
  }

  prepareFiles(dropClick: any) {

    // remove error message on subsequent upload attempt
    this.oopsMsg = false;

    // replace old file if a new one is uploaded
    if (this.illustrationFiles.length > 0) {
      this.illustrationFiles = [];
    }

    // build file array (not needed for Illustrations, which only accepts one file, but kept intact for future use)
    for (const item of dropClick) {
      item.progress = 1;
      this.illustrationFiles.push(item);
    }

    if (this.illustrationFiles.length > 1) {
      this.oopsMsg = this.tooManyFiles;
      this.illustrationFiles = [];
      return;
    }

    if (this.illustrationFiles[0].type !== 'application/pdf') {
      this.oopsMsg = this.onlyPDFs;
      this.illustrationFiles = [];
      return;
    }

    if (this.isOptional === false) {
      this.filePickerFormGroup.controls['Response'].setValue(null);
      this.filePickerFormGroup.controls['Upload'].setValidators(Validators.required);
      this.filePickerFormGroup.controls['Response'].setValidators(Validators.required);
      this.filePickerFormGroup.updateValueAndValidity();
      this.cdr.markForCheck();
    }

    // begin simulated progress meter
    this.progressMeter(0);
    // begin upload
    this.illustrationStart ? this.uploadIllustrationStart() : this.uploadIllustration();
  }

  formatBytes(bytes, decimals) {
    if (bytes === 'uploaded') {
      return 'already uploaded';
    }
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  async progressMeter(index: number) {
    const progressInterval = setInterval(() => {
      if (this.illustrationFiles.length === 0 || this.illustrationFiles[index].progress === 'break') {
        clearInterval(progressInterval);
        if (this.illustrationFiles.length > 0) {
          this.progressMeter(index + 1);
        }
      } else if (this.illustrationFiles[index].progress < 25) {
        this.illustrationFiles[index].progress += 1;
      } else if (this.illustrationFiles[index].progress < 95) {
        this.illustrationFiles[index].progress += 5;
      } else {
        clearInterval(progressInterval);
      }
      this.cdr.detectChanges();
    }, 200);
  }

}
